/* eslint-disable */
export const MODULE_NAME = 'search';
export const SEARCH_INPUT_MAX_LENGTH = 100;